import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { fetchAllProducts } from "../firebase/fireStoreServices";
import { Link, useNavigate } from "react-router-dom";

export default function Products() {
  /*const productsData = [
    {
      id: 1,
      name: "Chocolate Truffle Cake",
      image: "/images/products/Products_ChocolateCake.jpg",
      description: "Rich and creamy chocolate delight.",
    },
    {
      id: 2,
      name: "Red Velvet Cake",
      image: "/images/products/Products_RedVelvet.jpg",
      description: "Moist red velvet cake topped with creamy frosting.",
    },
    {
      id: 3,
      name: "Oreo Chocolate Cake",
      image: "/images/products/Products_OreoChoclateCake.jpg",
      description: "Chocolate and Oreo bliss in every bite.",
    },
    {
      id: 4,
      name: "Black Current Cake",
      image: "/images/products/Products_BlackCurrent_Car.jpg",
      description: "Soft cake bursting with blackcurrant flavor.",
    },
    {
      id: 5,
      name: "Butter Scotch Cake",
      image: "/images/products/Products_ButterScotch.jpg",
      description: "Rich, creamy cake with crunchy butterscotch.",
    },
    {
      id: 6,
      name: "Fresh Fruit Cake",
      image: "/images/products/Products_FruitCake.jpg",
      description: "Tangy and sweet with fresh blueberries.",
    },
    {
      id: 7,
      name: "Butter Scotch with Choco Chips",
      image: "/images/products/Products_ButterScotch_ChocoChips.jpg",
      description: "Crunchy butterscotch with rich choco chips.",
    },
    {
      id: 8,
      name: "Red Velvet Cake",
      image: "/images/products/Products_RedVelvet.jpg",
      description: "Soft and delicious with cream cheese frosting.",
    },
    {
      id: 9,
      name: "Oreo Chocolate Cake",
      image: "/images/products/Products_OreoChoclateCake.jpg",
      description: "Tangy and sweet with fresh blueberries.",
    },
    {
      id: 10,
      name: "Black Current Cake",
      image: "/images/products/Products_BlackCurrent_Car.jpg",
      description: "Rich and creamy chocolate delight.",
    },
    {
      id: 11,
      name: "Butter Scotch Cake",
      image: "/images/products/Products_ButterScotch.jpg",
      description: "Soft and delicious with cream cheese frosting.",
    },
    {
      id: 12,
      name: "Fruit Cake",
      image: "/images/products/Products_FruitCake.jpg",
      description: "Tangy and sweet with fresh blueberries.",
    },
  ];
*/
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  // Fetching Product data from database through service layer i.e. firebase/fireStoreServices
  useEffect(() => {
    const loadProducts = async () => {
      const prodData = await fetchAllProducts();
      setProducts(prodData);
    };
    loadProducts();
  }, []);

  const displayedProducts = products.slice(0, 12); // Limit 12 products to be displayed only

  return (
    <Container maxWidth="lg" sx={{ bgcolor: "white", mt: 3, borderRadius: 4 }}>
      <Divider>
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="secondary"
        >
          Our Products
        </Typography>
      </Divider>
      <Box sx={{ mt: 1, p: 3 }}>
        <Grid container spacing={2} justifyContent="center">
          {displayedProducts.map((product, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
              <Card
                sx={{
                  height: 280, // 🔹 Set a fixed height for all cards
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 5,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: 15,
                  },
                }}
                onClick={() => navigate(`/product/${product.id}`)}
              >
                <CardActionArea component={Link} to={`/product/${product.id}`}>
                  <CardMedia
                    component="img"
                    height="180"
                    image={product.image}
                    alt={product.title}
                    loading="lazy"
                    sx={{ objectFit: "cover", borderRadius: 2 }}
                  />
                  <CardContent sx={{ textAlign: "center" }}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="secondary"
                    >
                      {product.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {product.subtitle}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box textAlign="center" mt={4}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/all-products")}
          >
            View All Products
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
